require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ../~/angular/index.js
// module id = 43
// module chunks = 1